import React, { useEffect } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { RootState } from '@/app/store'
import { useSelector, useDispatch } from 'react-redux'
import Menu from '@/components/Menu'
import usePeriod from '@/lib/usePeriod'
import useNoLogin from '@/lib/useNoLogin'
import { pageToggleState } from '@/features/authSlice'
import useDeployTimeStamp from '@/lib/useDeployTimeStamp'
import { fetchAsyncGetCampaign } from '@/features/apiAsyncSlice'
import RegisterQuestionnaire from './RegisterQuestionnaire'
import Loading from './Loading'
import { useTranslation } from 'react-i18next'

type LayoutTYPE = {
  children: React.ReactNode
  title: string
  enableLoading?: boolean
}

const Layout = ({ children, title = `${process.env.NEXT_PUBLIC_SERVICE_NAME}`, enableLoading }: LayoutTYPE) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  useEffect(() => {
    dispatch(fetchAsyncGetCampaign())
  }, [dispatch])

  useDeployTimeStamp()
  usePeriod()
  useNoLogin()

  const periodSelector = useSelector((state: RootState) => state.auth.period)

  const pageToggleSelector = useSelector((state: RootState) => state.auth.pageToggle)

  const dialogRegisterQuestionnaireStateSelector = useSelector(
    (state: RootState) => state.dialog.dialogRegisterQuestionnaireState,
  )

  const router = useRouter()
  const { route } = router

  useEffect(() => {
    if (typeof window !== 'undefined' ? localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-clientid`) : '') {
      if (localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)) {
        dispatch(pageToggleState(true))
        return
      }

      if (router.pathname === '/auth/signin') {
        setTimeout(() => {
          dispatch(pageToggleState(true))
        }, 500)
        return
      }

      if (router.pathname === '/auth/register') {
        setTimeout(() => {
          dispatch(pageToggleState(true))
        }, 500)
        return
      }
    } else {
      if (router.pathname === '/auth/register') {
        setTimeout(() => {
          dispatch(pageToggleState(true))
        }, 500)

        return
      }

      if (router.pathname === '/auth/signin') {
        setTimeout(() => {
          dispatch(pageToggleState(true))
        }, 500)
      }

      return
    }
    return
  }, [])

  const handleRouteError = (err, url) => {
    if (err.cancelled) {
      console.log(`Route to ${url} was cancelled!`)
    }
  }

  useEffect(() => {
    router.events.on('routeChangeError', handleRouteError)
    return () => {
      router.events.off('routeChangeError', handleRouteError)
    }
  }, [router.events])

  if (periodSelector === false) {
    if (enableLoading) {
      return <Loading />
    } else {
      return <div>{''}</div>
    }
  }

  return (
    <div
      className={`c-wrapper ${periodSelector ? 'opacity-1' : pageToggleSelector ? 'opacity-1' : 'opacity-0'} ${
        route === '/spot' ? 'height-auto' : ''
      }`}
    >
      <Head>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"
        />
        <title>{title}</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;1,700&display=swap"
          rel="stylesheet"
        />
      </Head>
      {(() => {
        if (
          route === '/' ||
          route === '/period' ||
          route === '/notice' ||
          route === '/logout' ||
          route === '/qrerror' ||
          route === '/404' ||
          route === '/500' ||
          route === '/auth/register' ||
          route === '/auth/signin'
        ) {
          return
        } else {
          return (
            <header id="l_header" className="bg-bgHeader">
              <nav className="bg-white w-screen">
                <div className="flex items-center">
                  <div className="flex w-full px-3 py-3">
                    <Link href="/">
                      <a
                        className="flex items-center"
                        onClick={(e) => {
                          e.preventDefault()

                          if (!document.referrer || document.referrer.includes('/qr/')) {
                            router.push('/spot')
                            return
                          }

                          router.back()
                          return
                        }}
                      >
                        ＜
                        <span className="ml-4 block text-xsss font-bold text-color01">{t('common.back', '戻る')}</span>
                      </a>
                    </Link>
                  </div>
                </div>
              </nav>
            </header>
          )
        }
      })()}
      <main>
        {route === '/auth/register' ||
        route === '/auth/signin' ||
        route === '/logout' ||
        route === '/notice' ||
        route === '/qr' ||
        route === '/qrerror' ||
        route === '/404' ||
        route === '/500' ||
        route === '/period' ? (
          ''
        ) : (
          <Menu />
        )}
        {children}
        <style global jsx>{`
          :root {
            --env-url: ${process.env.NEXT_PUBLIC_SITEURL};
          }
        `}</style>
      </main>

      {route === '/auth/register' ||
      route === '/auth/signin' ||
      route === '/logout' ||
      route === '/notice' ||
      route === '/qr' ||
      route === '/qrerror' ||
      route === '/404' ||
      route === '/500' ||
      route === '/period' ? null : dialogRegisterQuestionnaireStateSelector ? (
        <RegisterQuestionnaire />
      ) : null}
    </div>
  )
}
export default Layout
